import { Enrollment } from '@clear-denver/tpc-openapi-typescript'
import { DiscreteEvent, dispatchCustomEvent, KPI } from '@utils/customEvents'

import type { FunnelEvent } from './types'

export const emitFunnelEvent = (event: FunnelEvent) => {
  dispatchCustomEvent(Enrollment.LogEntryLevelEnum.INFO, {
    payload: {
      message: `funnel:${event.funnel_route_from_page}->${event.funnel_route_to_page}`,
    },
    metadata: {
      xCLEARCorrelationInfo: '',
      kpi: KPI.PAGE_VIEW,
      event: DiscreteEvent.FUNNEL_ROUTE_TRANSITION,
      ...event,
    },
  })
}
